import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Renders a JSON-LD <script> tag inside <head> via react-helmet-async.
 * Pass a plain JS object — it will be serialized.
 */
export const JsonLd = ({ data }) => (
    <Helmet>
        <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
);

export default JsonLd;
